import { IconTooltip } from '../ui/tooltip';
import { cn } from '../ui/utils';
import { ProviderIcon } from './ProviderIcon';
import { ediscoverySystemName } from './requestMeta';

interface EDiscoverySourceBadgeProps {
  // The eDiscovery system (e.g. "purview"): picks the logo and the tooltip.
  system: string;
  className?: string;
}

// Small icon marking a Case that ingested files from an eDiscovery system
// (Purview, …): the system's logo, its name in the tooltip (FB-1021).
export function EDiscoverySourceBadge({ system, className }: EDiscoverySourceBadgeProps) {
  const name = ediscoverySystemName(system);
  const label = name ? `Imported from ${name}` : 'Imported from eDiscovery';
  return (
    <IconTooltip label={label}>
      <span
        data-testid="ediscovery-source"
        data-system={system.toLowerCase()}
        role="img"
        aria-label={label}
        className={cn(
          'inline-flex h-6 w-6 items-center justify-center rounded-sm bg-primary/10 text-primary',
          className,
        )}
      >
        <ProviderIcon provider={system} />
      </span>
    </IconTooltip>
  );
}
